// InitialRedirect.js
import { Navigate } from "react-router-dom";
import { LAST_PATH_KEY } from "../contexts/GlobalContext";

function InitialRedirect() {
  const savedPath = localStorage.getItem(LAST_PATH_KEY);

  const isValidPath = (path) => ["/tags"].some((p) => savedPath?.startsWith(p));

  const redirectTo = isValidPath(savedPath) ? savedPath : "/tags";

  return <Navigate to={redirectTo} replace />;
}

export default InitialRedirect;
